export default __webpack_public_path__ + "static/media/close.1e94e4fb.svg";